import {UIElement} from '../ui-element'
import {DataObjectId} from 'yougile-model'

export class RawHtmlEl extends UIElement {
  private _html: string

  constructor(companyId: DataObjectId, html: string) {
    super(companyId, undefined, undefined)
    this._html = html
  }

  public get html(): string {
    return this._html
  }

  public set html(val: string) {
    this._html = val
    this.refresh()
  }

  public override render(el: HTMLElement): void {
    el.className = 'ui-raw-html'
    el.innerHTML = this._html
    super.render(el)
  }
}
